import React, { useState } from 'react'

import {
  InvoiceTableHeader,
  InvoiceTableHeaderText,
  InvoiceTableStyled,
} from 'Features/accountSettings/components/Billing/InvoicesTable/InvoiceTable.styled'
import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'Assets/icons/ChevronDown'
import { IconButton } from 'Components/Elements/IconButton/IconButton.styled'
import { InvoicesRows } from 'Features/accountSettings/components/Billing/InvoicesTable/Invoices'

type InvoicesTableProps = {
  numOfRows: number | 'all'
}

const chevronDownColor = '#9B9B9B'

export const InvoicesTable = ({ numOfRows }: InvoicesTableProps) => {
  const { t } = useTranslation('accountSettings')
  const [sortBy, setSortBy] = useState<'date' | 'payment' | 'amount' | 'status'>('date')

  return (
    <InvoiceTableStyled>
      <InvoiceTableHeader>
        <InvoiceTableHeaderText onClick={() => setSortBy('date')}>
          <IconButton aria-label="sort by date">
            {t('billing_page.issue_date')}
            <ChevronDown color={chevronDownColor} />
          </IconButton>
        </InvoiceTableHeaderText>
        <InvoiceTableHeaderText onClick={() => setSortBy('payment')}>
          <IconButton aria-label="sort by payment">
            {t('billing_page.payment')}
            <ChevronDown color={chevronDownColor} />
          </IconButton>
        </InvoiceTableHeaderText>
        <InvoiceTableHeaderText onClick={() => setSortBy('amount')}>
          <IconButton aria-label="sort by price">
            {t('billing_page.price')}
            <ChevronDown color={chevronDownColor} />
          </IconButton>
        </InvoiceTableHeaderText>
        <InvoiceTableHeaderText onClick={() => setSortBy('status')}>
          <IconButton aria-label="sort by status">
            {t('billing_page.status')}
            <ChevronDown color={chevronDownColor} />
          </IconButton>
        </InvoiceTableHeaderText>
      </InvoiceTableHeader>
      <InvoicesRows sortBy={sortBy} numOfRows={numOfRows} />
    </InvoiceTableStyled>
  )
}
